import { ReactNode } from 'react';
import { Card } from './Card';

export interface FormSectionProps {
    title: string;
    description?: string;
    children: ReactNode;
}

/** Card with a title and a grid of fields. Use `sm:grid-cols-2` on children only for short paired fields. */
export const FormSection = ({ title, description, children }: FormSectionProps) => (
    <Card as="section" padding="lg">
        <h2 className="text-title text-strong">{title}</h2>
        {description && <p className="mt-1 text-small text-muted">{description}</p>}
        <div className="mt-4 grid gap-4 sm:mt-5 sm:gap-5">{children}</div>
    </Card>
);
